import React from "react";
import ClassNames from "classnames";
import { Link } from "gatsby";
import { LocaleConsumer } from "../Layout";
import { getLocalizedPath } from "../../helperFunctions";
import * as s from "./s.module.scss";

const Button = ({
  children,
  onClick,
  ariaLabel,
  className,
  variant,
  size,
  icon,
  iconPosition,
  arrow,
  link,
  external,
  style,
  type,
  position,
  ...props
}) => {
  const btnVariant = {
    [s.btnPrimary]: variant === "primary",
    [s.btnSecondary]: variant === "secondary",
    [s.btnBlue]: variant === "blue",
    [s.btnBlack]: variant === "black",
    [s.btnOrange]: variant === "orange",
    [s.btnGrey]: variant === "grey",
  };

  const btnSize = {
    [s.btnRvSmall]: size === "rvSmall",
    [s.btnSmall]: size === "small",
  };

  const btnArrow = {
    [s.btnArrow]: arrow,
  };

  const btnPosition = {
    [s.btnLgCenter]: position === "lg_center",
  };

  let component;

  switch (iconPosition) {
    case "left":
      external
        ? (component = (
            <a
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                s.iconLeft,
                btnArrow,
                btnPosition,
                className
              )}
              href={link}
              onClick={onClick}
              target="_blank"
              rel="noopener noreferrer"
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
            >
              {icon}
              {children}
            </a>
          ))
        : type === "submit"
        ? (component = (
            <button
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                s.iconLeft,
                btnArrow,
                btnPosition,
                className
              )}
              to={link}
              onClick={onClick}
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
            >
              {icon}
              {children}
            </button>
          ))
        : (component = (
            <LocaleConsumer>
              {({ locale, alias }) => (
                <Link
                  className={ClassNames(
                    s.button,
                    btnVariant,
                    btnSize,
                    s.iconLeft,
                    btnArrow,
                    btnPosition,
                    className
                  )}
                  to={
                    typeof locale !== "undefined"
                      ? getLocalizedPath(locale, alias, link)
                      : link
                  }
                  onClick={onClick}
                  {...props}
                  aria-label={ariaLabel ? ariaLabel : "button"}
                >
                  {icon}
                  {children}
                </Link>
              )}
            </LocaleConsumer>
          ));
      break;
    case "right":
      external
        ? (component = (
            <a
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                s.iconRight,
                btnArrow,
                btnPosition,
                className
              )}
              href={link}
              onClick={onClick}
              target="_blank"
              rel="noopener noreferrer"
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
            >
              {children}
              {icon}
            </a>
          ))
        : type === "submit"
        ? (component = (
            <button
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                s.iconRight,
                btnArrow,
                btnPosition,
                className
              )}
              to={link}
              onClick={onClick}
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
            >
              {children}
              {icon}
            </button>
          ))
        : (component = (
            <LocaleConsumer>
              {({ locale, alias }) => (
                <Link
                  className={ClassNames(
                    s.button,
                    btnVariant,
                    btnSize,
                    s.iconRight,
                    btnArrow,
                    btnPosition,
                    className
                  )}
                  to={
                    typeof locale !== "undefined"
                      ? getLocalizedPath(locale, alias, link)
                      : link
                  }
                  onClick={onClick}
                  {...props}
                  aria-label={ariaLabel ? ariaLabel : "button"}
                >
                  {children}
                  {icon}
                </Link>
              )}
            </LocaleConsumer>
          ));
      break;
    default:
      external
        ? (component = (
            <a
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                btnArrow,
                btnPosition,
                className
              )}
              href={link}
              target="_blank"
              onClick={onClick}
              style={style}
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
              rel="noreferrer"
            >
              {children && children}
              {icon}
            </a>
          ))
        : type === "submit"
        ? (component = (
            <button
              className={ClassNames(
                s.button,
                btnVariant,
                btnSize,
                btnArrow,
                btnPosition,
                className
              )}
              to={link}
              onClick={onClick}
              style={style}
              {...props}
              aria-label={ariaLabel ? ariaLabel : "button"}
            >
              {children && children}
              {icon}
            </button>
          ))
        : (component = (
            <LocaleConsumer>
              {({ locale, alias }) => (
                <Link
                  className={ClassNames(
                    s.button,
                    btnVariant,
                    btnSize,
                    btnArrow,
                    btnPosition,
                    className
                  )}
                  to={
                    typeof locale !== "undefined"
                      ? getLocalizedPath(locale, alias, link)
                      : link
                  }
                  onClick={onClick}
                  style={style}
                  {...props}
                  aria-label={ariaLabel ? ariaLabel : "button"}
                >
                  {children}
                  {icon}
                </Link>
              )}
            </LocaleConsumer>
          ));
  }

  return component;
};

export default Button;
